import { stripeClient } from "@better-auth/stripe/client";
import {
  emailOTPClient,
  inferAdditionalFields,
  usernameClient,
} from "better-auth/client/plugins";
import { createAuthClient } from "better-auth/react";
import type { nextAuth } from "./next";

export const authClient = createAuthClient({
  plugins: [
    inferAdditionalFields<typeof nextAuth>(),
    emailOTPClient(),
    // phoneNumberClient(),
    stripeClient({
      subscription: true, //if you want to enable subscription management
    }),
    usernameClient(),
  ],
});
